export class PriceListUploadDTO {
  providerNetworkCode: string;
  providerPracticeNumber: string;
  codingSchemaCode: string;
  proprietaryCode: string;
  proprietaryDescription: string;
  currency: string;
  grossAmount: string;
  discountAmount: string;
  startDate: string;
  endDate: string;
}
